import React, { useState, useEffect } from "react";
import "./ChatCss.css";
import { BASE_URL } from '../Config';

const ChatWindow = () => {
    const [minimized, setMinimized] = useState(true);
    const [selectedContact, setSelectedContact] = useState(null);
    const [contacts, setContacts] = useState([]);
    const [messages, setMessages] = useState([]);
    const [loadingImage, setLoadingImage] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    const fetchContactsAndMessages = async () => {
        try {
            const contactRes = await fetch(`${BASE_URL}/api/message/contact`, {
                method: "GET",
                headers: {
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
            });
            const contactData = await contactRes.json();
            const groupedContacts = contactData.reduce((acc, curr) => {
                const contactIndex = acc.findIndex((c) => c.wa_id === curr.wa_id);
                if (contactIndex === -1) {
                    acc.push({ ...curr, messages: [curr] });
                } else {
                    acc[contactIndex].messages.push(curr);
                }
                return acc;
            }, []);
            groupedContacts.forEach((contact) =>
                contact.messages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
            );

            const clientRes = await fetch(`${BASE_URL}/api/message/clientmsg`, {
                method: "GET",
                headers: {
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
            });
            const clientData = await clientRes.json();

            clientData.forEach((clientMsg) => {
                const contactIndex = groupedContacts.findIndex(
                    (c) => c.wa_id === clientMsg.wa_id
                );
                if (contactIndex === -1) {
                    groupedContacts.push({
                        wa_id: clientMsg.wa_id,
                        phoneNumber: clientMsg.phoneNumber,
                        name: "Unknown",
                        messages: [{ ...clientMsg, sender: "client" }],
                    });
                } else {
                    const isDuplicate = groupedContacts[contactIndex].messages.some(
                        (msg) => msg.createdAt === clientMsg.createdAt
                    );
                    if (!isDuplicate) {
                        groupedContacts[contactIndex].messages.push({
                            ...clientMsg,
                            sender: "client",
                        });
                    }
                }
            });

            setContacts(groupedContacts);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchContactsAndMessages();

        const intervalId = setInterval(() => {
            fetchContactsAndMessages();
        }, 180000); // 3 minutes interval

        return () => clearInterval(intervalId);
    }, []);


    const toggleMinimize = () => setMinimized(!minimized);

    const handleSelectContact = (wa_id) => {
        const contactMessages = contacts.find(
            (contact) => contact.wa_id === wa_id
        )?.messages || [];
        contactMessages.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        setSelectedContact(contactMessages[0]);
        setMessages(contactMessages);
    };

    const handleSendMessage = async (e) => {
        e.preventDefault();

        const messageText = e.target.message.value;
        if (!selectedContact) {
            alert("Please select a contact first!");
            return;
        }

        const phoneNumber = selectedContact.wa_id;

        const newMessage = {
            sender: "client",
            text: messageText,
            createdAt: new Date().toISOString(),
            status: "sending",
        };

        setMessages((prevMessages) => [...prevMessages, newMessage].sort(
            (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
        ));
        e.target.reset();

        try {
            const response = await fetch(`${BASE_URL}/api/message`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "wabaId": localStorage.getItem("WabaId"),
                    "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                },
                body: JSON.stringify({
                    phoneNumber: phoneNumber,
                    message: messageText,
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to send message");
            }

            const data = await response.json();

            setMessages((prevMessages) =>
                prevMessages.map((msg) =>
                    msg.createdAt === newMessage.createdAt
                        ? { ...msg, status: "sent" }
                        : msg
                )
            );
        } catch (error) {
            console.error("Error sending message:", error);
            alert("Failed to send the message. Please try again.");

            setMessages((prevMessages) =>
                prevMessages.filter((msg) => msg.createdAt !== newMessage.createdAt)
            );
        }
    };

    const handleImageTap = async (msg) => {
        if (!loadingImage) {
            setLoadingImage(true);
            try {
                const response = await fetch(`${BASE_URL}/api/message/getImage/${msg.content.imageId}`, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        "wabaId": localStorage.getItem("WabaId"),
                        "phoneNumberId": localStorage.getItem("ClientPhoneNumberId"),
                    }
                });
                const imageRes = await response.json();
                console.log('imageRes0', imageRes);

                if (response.ok) {
                    const imageUrl = imageRes.url;
                    setImageUrl(imageUrl);
                    console.log('imagesssss', imageUrl);

                } else {
                    console.error("Failed to load image");
                }
            } catch (error) {
                console.error("Error fetching image:", error);
            } finally {
                setLoadingImage(false);
            }
        }
    };

    const renderStatus = (status) => {
        switch (status) {
            case "sending":
                return <span className="status sending">✔</span>;
            case "sent":
                return <span className="status sent">✔</span>;
            case "delivered":
                return <span className="status delivered">✔✔</span>;
            case "read":
                return <span className="status read">✔✔</span>;
            case "failed":
                return <span className="status failed">❌</span>;
            default:
                return <span className="status unknown">?</span>;
        }
    };

    return (
        <div className={`chat-window ${minimized ? "minimized" : "maximized"}`}>
            <button className="toggle-button" onClick={toggleMinimize}>
                {minimized ? "Open Chat" : "Close Chat"}
            </button>

            {!minimized && (
                <div className="chat-content">
                    <div className="contact-list">
                        {contacts.map((contact, index) => (
                            <div
                                key={index}
                                className={`contact-item ${selectedContact?.wa_id === contact.wa_id ? "selected" : ""}`}
                                onClick={() => handleSelectContact(contact.wa_id)}
                            >
                                {contact.wa_id || "Unknown Contact"}
                            </div>
                        ))}
                    </div>

                    <div className="chat-box">
                        {selectedContact && (
                            <>
                                <div className="chat-messages">
                                    {messages.map((msg, index) => (
                                        <div
                                            key={index}
                                            className={`chat-message ${msg.sender === "client" ? "client" : "user"}`}
                                        >
                                            <span className="message-text">
                                                {msg.sender === "client" ? (
                                                    msg.content || msg.message || msg.text || `Template Name - ${msg.templeteName}` || "[No message content]"
                                                ) : (
                                                    typeof msg.content === "string" ? (
                                                        msg.content
                                                    ) : msg.content?.type === "image" ? (
                                                        <div className="image-box" onClick={() => handleImageTap(msg)}>
                                                            {loadingImage ? (
                                                                <span>Loading...</span>
                                                            ) : imageUrl ? (
                                                                <img
                                                                    src={imageUrl}
                                                                    alt="Message content"
                                                                    className="message-image"
                                                                />
                                                            ) : (
                                                                <span>Tap to load image</span>
                                                            )}
                                                        </div>
                                                    ) : (
                                                        "[Unsupported content]"
                                                    )
                                                )}
                                            </span>
                                            <div className="message-time-status">
                                                <span className="message-time">
                                                    {new Date(msg.createdAt).toLocaleDateString()}{" "}
                                                    {new Date(msg.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                                                </span>
                                                {msg.sender === "client" && renderStatus(msg.latestStatus)}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <form onSubmit={handleSendMessage} className="chat-input">
                                    <input
                                        type="text"
                                        name="message"
                                        placeholder="Type a message..."
                                        required
                                    />
                                    <button type="submit">Send</button>
                                </form>
                            </>
                        )}
                    </div>
                </div>
            )}
        </div>
    );

};

export default ChatWindow;
